/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { default as ReactModal } from 'react-modal';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    onClose: PropTypes.func,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Modal = (props) => {
    const classNames = [
        'c-modal',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <ReactModal
            overlayClassName="c-modal__backdrop"
            isOpen
            contentLabel="Modal"
            appElement={document.querySelector('.c-dashboard-left-panel')}
            onRequestClose={props.onClose}
            ariaHideApp={false}
            shouldCloseOnOverlayClick
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </ReactModal>
    );
};

Modal.propTypes = propTypes;

Modal.defaultProps = defaultProps;

export default Modal;
